import React from "react";
import Container from "../Common/Container";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ImageProps, PartnersProps } from "./interfaces/Partners";
import {
  ArrowLeftCircleIcon,
  ArrowRightCircleIcon,
} from "@heroicons/react/24/outline";
import Text from "../Common/Text";

const DEFAULT_DATA: PartnersProps = {
  images: [
    {
      id: "1",
      image: {
        desktop:
          "https://assets.dogtorsoftware.com/1/website/44150874-9759-40e1-8ea7-781f3cfc8412.png",
      },
    },
    {
      id: "2",
      image: {
        desktop:
          "https://assets.dogtorsoftware.com/1/website/97e04d97-2c0d-4d89-8399-6416e88b3bc8.png",
      },
    },
    {
      id: "3",
      image: {
        desktop:
          "https://assets.dogtorsoftware.com/1/website/fcdf0c9a-100d-4296-8b25-73158143de5c.jpg",
      },
    },
    {
      id: "4",
      image: {
        desktop:
          "https://assets.dogtorsoftware.com/1/website/13c50b38-9a70-46ea-8e9e-5987e9ac6134.jpg",
      },
    },
  ],
  total: "3",
  title: { value: "Nuestros aliados" },
};

const Partners = ({
  data = DEFAULT_DATA,
  onChange,
}: {
  data: PartnersProps;
  onChange: (value: any, id?: string) => void;
}) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplaySpeed: parseInt(data?.time || "2", 10) * 1000,
    autoplay: true,
    slidesToShow: parseInt(data?.total || "4", 10),
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <ArrowRight />,
    prevArrow: <ArrowLeft />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          infinite: true,
        },
      },
    ],
  };
  return (
    <div className="my-10">
      <Container>
        <Text
          editor={!!onChange}
          id="Partners"
          onChange={(val: any) => onChange?.(val, "title")}
        >
          {data?.title}
        </Text>
        <div className="slider-container mt-5">
          <Slider {...settings}>
            {data?.images?.map((item) => (
              <Slide image={item?.image} key={item?.id} url={item.url} />
            ))}
          </Slider>
        </div>
      </Container>
    </div>
  );
};

const Slide = ({ image, url }: ImageProps) => {
  return (
    <div className="px-4">
      <a href={url || "#"} target="_blank" rel="noreferrer">
        <img className="w-full h-auto" src={image?.desktop} alt=""></img>
      </a>
    </div>
  );
};

const ArrowRight = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <ArrowRightCircleIcon
      aria-hidden="true"
      className={`${className} `}
      onClick={onClick}
      style={{
        ...style,
        display: "block",
        color: "var(--primary900)",
        width: "30px",
        height: "30px",
      }}
    />
  );
};
const ArrowLeft = (props: any) => {
  const { className, style, onClick } = props;
  return (
    <ArrowLeftCircleIcon
      aria-hidden="true"
      className={`${className} `}
      onClick={onClick}
      style={{
        ...style,
        display: "block",
        color: "var(--primary900)",
        width: "30px",
        height: "30px",
      }}
    />
  );
};

export default Partners;
